import { h } from "preact";
import { RoutableProps } from "preact-router";
import { resolvePath } from "../../../api";
import { addProductToDatabase, ManufacturingConfiguration, ProductType } from "../../../api/product-api";
import { manufacturingConfigurations } from "../../../App";
import { AccessoriesPrinting, SerialNumberData } from "../../../components/AccesoriesPrinting";
import "./styles.scss";

export function MezosSITSerialNumber(props: RoutableProps) {
    return <div class="orion-sit-serial-number-page">
        <AccessoriesPrinting manufacturingConfigurations={manufacturingConfigurations["MezosSIT"] ?? []} serialType="serial-8-base32" generateSerialNumber={(type) => addProductToDatabase(type)}/>
    </div>;
}
